











































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import GtCapsuleTag from "@root/components/GtCapsuleTag/index.vue";
const tagManager = namespace("tagManager");
import add from "./add.vue";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl
} from "@root/lib/decorator";
@Component({
  components: { add, GtCapsuleTag }
})
@SearchbarControl()
@pagination("getDataList", { pageSize: 50 })
@loading(true)
export default class roleManagerPage extends Vue {
  form: any = {
    tagName: ""
  };
  loading: boolean = false;
  total: number = 0;
  isEdit: boolean = false;
  @tagManager.Action getTagList;
  @tagManager.Action deleteTag;
  @tagManager.State dataList;
  @tagManager.Action updateTag;
  editData: any = null;
  searchFormOptions: any = {
    form: [
      {
        label: "标签名称",
        key: "tagName",
        type: "input",
        value: ""
      }
    ],
    loading: false
  };
  mounted() {
    this.getDataList();
  }
  onFormDataChange(data) {
    this.form = { ...data };
  }
  async getDataList() {
    const { pageSize, currentPage: pageNum }: any = this;
    try {
      this.loading = true;
      let { total } = await this.getTagList({
        ...this.form,
        pageInput: {
          pageSize,
          pageNum
        }
      });
      this.total = total;
    } catch {
      //
    } finally {
      this.loading = false;
    }
  }
  handleAdd() {
    this.editData = null;
    this.isEdit = false;
    (this as any).$refs.addTag.dialogVisible = true;
  }
  handleEdit(data) {
    this.editData = data;
    this.isEdit = true;
    (this as any).$refs.addTag.dialogVisible = true;
  }
  async handleDelete(data) {
    if (data.tagState === "0") {
      this.$message.error("标签启用状态下不能删除");
      return;
    }
    await this.$confirm("你确定要删除这个标签吗？");
    await this.deleteTag({ tagCode: data.tagCode });
    this.$message({ type: "success", message: "删除成功" });
    this.refresh(0);
  }
  async handleUpdateStatue(data) {
    let { tagCode, tagState } = data;
    await this.updateTag({
      input: { tagCode, tagState: tagState === "0" ? "1" : "0" }
    });
    this.refresh(1);
  }
  refresh(flag) {
    //1 是编辑 0 是新增
    if (flag === 1) {
      this.getDataList();
    } else {
      (this as any).currentPage = 1;
      this.getDataList();
    }
  }
}
